import moment from 'moment';
import { writeFile, utils } from 'xlsx-js-style';

export function GenerateExcelFile(fileName: string, headers: any, data: any, sheetName?: string) {
    let sName = "Ark";

    if (sheetName !== undefined) {
        sName = sheetName;
    }

    const worksheet = utils.json_to_sheet(data);
    fixWidth(worksheet);
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, sName);
    writeFile(workbook, fileName + "_" + moment().format('DD-MM-YYYY') + ".xlsx");

    function fixWidth(worksheet: any) {
    const data = utils.sheet_to_json<any>(worksheet)
    const colLengths = headers.map((k) => k.toString().length > 20?20:k.toString().length) // Set initial column lengths based on headers, max 40 characters
    for (const d of data) {        
      Object.values(d).forEach((element: any, index) => {
        const length = element?.toString().length
        if (colLengths[index] < length) {
          colLengths[index] = length > 20 ? 20 : length; // Ensure max length is 40 characters
        }
      })
    }

    worksheet["!cols"] = colLengths.map((l) => {
      return {
        wch: l + 2,
      }
    })
  }
}


